export default "__VITE_ASSET__C_PaS_Iu__"